<template>
  <v-row class="pt-5" v-if="localTiles">
    <v-col cols="10" offset="1">
      <tiles-moodboard v-if="summaryMode == 'collated'" :tiles="filteredTiles" :key="this.model" :name="this.model" />
      <tiles-images v-if="summaryMode == 'images'" :tiles="filteredSort" />
      <tiles-words v-if="summaryMode == 'words'" :tiles="filteredSort" />
    </v-col>
  </v-row>
</template>

<script>
import lodash from "lodash";
import { mapState } from "vuex";
import { store } from "@/store.js";
const fb = require("@/firebaseConfig.js");
import {
  TilesMoodboard,
  TilesImages,
  TilesWords,
} from "@/components/results/tiles/modules";

export default {
  name: "ResultsTileSummary",
  data() {
    return {
      iso: null,
      intervalId: null,
      ready: false,
      max: 0,
      content: null,
    };
  },
  props: {
    id: String,
    model: String,
    localTiles: {
      type: Array,
      default: () => [],
    },
    summaryMode: {
      type: String,
      default: "combined",
    },
  },
  components: {
    TilesMoodboard,
    TilesImages,
    TilesWords,
  },
  watch: {
    summaryMode(val) {
      if (val) {
        this.init();
      }
    },
  },
  mounted() {
    this.getTiles();
    this.init();
  },
  computed: {
    ...mapState(["tiles"]),
    filteredSort() {
      return this.localTiles
        ? lodash.orderBy(this.filteredTiles, "count", "desc")
        : [];
    },
    filteredWords() {
      return this.filteredSort
        ? this.filteredTiles.filter((item) => item.type == "Word")
        : [];
    },
    containerId() {
      return this.id;
    },
    filteredTiles() {
      if (this.localTiles) {
        let items = [];
        let distribution = this.localTiles.reduce(
          (acum, cur) =>
            Object.assign(acum, { [cur.id]: (acum[cur.id] | 0) + 1 }),
          {}
        );
        for (var element in distribution) {
          items.push({ el: element, count: distribution[element] });
        }
        items.map((x) => {
          let tile = this.tiles.find((item) => item.id === x.el);
          if (tile) {
            x.title = tile.title;
            x.width = this.getWidth(x.count);
            x.type = tile.type;
            x.src = tile.src;
            x.percentage = this.getPercentage(x.count);
            x.category = tile.category;
            x.size = this.getFontSize(x.count);
          }
        });
        return items;
      } else {
        return null;
      }
    },
    filteredCounts() {
      if (this.localTiles) {
        let items = [];
        let distribution = this.localTiles.reduce(
          (acum, cur) =>
            Object.assign(acum, { [cur.id]: (acum[cur.id] | 0) + 1 }),
          {}
        );
        for (var element in distribution) {
          items.push(distribution[element]);
        }
        return items;
      } else {
        return null;
      }
    },
  },
  methods: {
    init() {
      let vm = this;
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.intervalId = setInterval(function () {
        vm.checkStatus();
      }, 300);
    },
    setMax() {
      if (this.localTiles) {
        this.max = Math.max.apply(null, this.filteredCounts);
      } else {
        return;
      }
    },
    checkStatus() {
      if (this.tiles && this.localTiles && this.localTiles.length) {
        this.ready = true;
        this.setMax();
        clearInterval(this.intervalId);
      }
    },
    layout() {
      this.iso.layout();
    },
    getTiles() {
      let ref = fb.tilesCollection;
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            // this.tiles = items;
            store.commit("setTiles", items);
            console.log("got tiles", items);
          }
        })
        .catch(function () { });
    },
    getWidth(count) {
      let limit = 50;
      let unit = limit / this.max;
      return `${count * unit}%`;
    },
    getFontSize(count) {
      let limit = 4;
      let unit = limit / this.max;
      return `${count * unit}rem`;
    },
    getPercentage(count) {
      let unit = 100 / this.max;
      return `${count * unit}%`;
    },
  },
};
</script>
